import { useEffect } from 'react';
import { websiteSettingsAPI } from '../../services/api';

const DocumentHead = () => {
  useEffect(() => {
    const updateDocumentHead = async () => {
      try {
        const response = await websiteSettingsAPI.getSettings();
        console.log('DocumentHead - Settings response:', response);
        if (response.data) {
          const settings = response.data;
          console.log('DocumentHead - Updating head with:', {
            website_name: settings.website_name,
            meta_title: settings.meta_title,
            favicon_path: settings.favicon_path,
            logo_path: settings.logo_path
          });
          
          // Update document title
          if (settings.website_name || settings.meta_title) {
            document.title = settings.meta_title || settings.website_name || 'EWHRDN';
          }
          
          // Update favicon
          if (settings.favicon_path) {
            // Remove existing favicon links
            const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
            existingFavicons.forEach(link => link.remove());
            
            // Create new favicon link
            const faviconLink = document.createElement('link');
            faviconLink.rel = 'icon';
            faviconLink.type = settings.favicon_path.includes('.ico') ? 'image/x-icon' : 'image/png';
            faviconLink.href = settings.favicon_path;
            document.head.appendChild(faviconLink);
            
            // Also add as apple-touch-icon
            const appleTouchIcon = document.createElement('link');
            appleTouchIcon.rel = 'apple-touch-icon';
            appleTouchIcon.href = settings.favicon_path;
            document.head.appendChild(appleTouchIcon);
          }
          
          // Update meta description
          if (settings.meta_description) {
            let metaDesc = document.querySelector('meta[name="description"]');
            if (!metaDesc) {
              metaDesc = document.createElement('meta');
              metaDesc.setAttribute('name', 'description');
              document.head.appendChild(metaDesc);
            }
            metaDesc.setAttribute('content', settings.meta_description);
          }
          
          // Update meta keywords
          if (settings.meta_keywords) {
            let metaKeywords = document.querySelector('meta[name="keywords"]');
            if (!metaKeywords) {
              metaKeywords = document.createElement('meta');
              metaKeywords.setAttribute('name', 'keywords');
              document.head.appendChild(metaKeywords);
            }
            metaKeywords.setAttribute('content', settings.meta_keywords);
          }
          
          // Update OG tags
          if (settings.og_title) {
            let ogTitle = document.querySelector('meta[property="og:title"]');
            if (!ogTitle) {
              ogTitle = document.createElement('meta');
              ogTitle.setAttribute('property', 'og:title');
              document.head.appendChild(ogTitle);
            }
            ogTitle.setAttribute('content', settings.og_title);
          }
          
          if (settings.og_description) {
            let ogDesc = document.querySelector('meta[property="og:description"]');
            if (!ogDesc) {
              ogDesc = document.createElement('meta');
              ogDesc.setAttribute('property', 'og:description');
              document.head.appendChild(ogDesc);
            }
            ogDesc.setAttribute('content', settings.og_description);
          }
          
          if (settings.og_image_path) {
            let ogImage = document.querySelector('meta[property="og:image"]');
            if (!ogImage) {
              ogImage = document.createElement('meta');
              ogImage.setAttribute('property', 'og:image');
              document.head.appendChild(ogImage);
            }
            ogImage.setAttribute('content', settings.og_image_path);
          }
        }
      } catch (error) {
        console.error('Error updating document head:', error);
      }
    };
    
    updateDocumentHead();
  }, []);

  return null; // This component doesn't render anything
};

export default DocumentHead;

